export enum CasinoRecommendationsKey {
	SPORTSBOOK_EXPLORE_KEY = 'sportsbook-explore',
	DEPOSIT_SUCCESS_KEY = 'deposit-success',
	CLOSE_ACCOUNT_FEEDBACK_KEY = 'close-account-feedback',
	FREE_TO_PLAY_KEY = 'free-to-play'
}
